export default __webpack_public_path__ + "static/media/apple.3dff327f.svg";